/* eslint-disable */

/*
 * This is a generated file created by deere-ui-svg-to-react.
 *
 * Please do not modify this file directly as it will be regenerated at build time.
 */

"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

exports["default"] = _react2["default"].createClass({
    displayName: "calculator",

    getDefaultProps: function getDefaultProps() {
        return {
            "st0": {
                "fill": "#666767"
            },
            "calculator": {
                "backgroundImage": "none",
                "backgroundPosition": "0% 0%",
                "display": "inline",
                "fill": "#333"
            },
            "width": "17",
            "height": "23"
        };
    },

    render: function render() {
        return _react2["default"].createElement(
            "svg",
            { id: "Layer_1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 17 23", className: "calculator", width: this.props.width, height: this.props.height, style: this.props.calculator },
            _react2["default"].createElement("path", { className: "st0", d: "M15.1 0H1.9C.8 0 0 .8 0 1.9v19.3c0 1 .8 1.9 1.9 1.9h13.3c1 0 1.9-.8 1.9-1.9V1.9C17 .8 16.2 0 15.1 0zM4.8 20.2h-3v-3h3v3zm0-5.1h-3v-3h3v3zm5.2 5.1H7v-3h3v3zm0-5.1H7v-3h3v3zm4.9 5.1h-3v-3h3v3zm0-5.1h-3v-3h3v3zm.1-5.5H2v-7h13v7z", style: this.props.st0 })
        );
    }
});

/* eslint-enable */
module.exports = exports["default"];



// WEBPACK FOOTER //
// ./~/cap-it-ui.toggles/~/cap-it-ui.icons/lib/calculator.js